import { axiosInstance, getAuthorizationHeaders } from '@/services/base';

export function uploadPopulatedCsv({ file }) {
    const urlString = `/admin/payroll/upload-populated-csv`;
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post(urlString, formData, {
        headers: { ...getAuthorizationHeaders().headers, 'Content-Type': 'multipart/form-data' },
    });
}

export function viewSalary(data) {
    const urlString = `/admin/payroll/view-submitted-salary`;
    return axiosInstance.post(urlString, data, {
        responseType: 'arraybuffer',
        headers: {
            ...getAuthorizationHeaders().headers,
            'Content-Type': 'application/json',
            Accept: 'application/pdf',
            encode: 'null',
        },
    });
}

export function sendPayslip(data) {
    const urlString = `/admin/payroll/send-payslip-to-employee`;
    return axiosInstance.post(urlString, data, {
        headers: { ...getAuthorizationHeaders().headers },
    });
}

export function downloadPayslip(data) {
    const urlString = `/users/payslip/download`;
    return axiosInstance.post(urlString, data, {
        headers: { ...getAuthorizationHeaders().headers },
    });
}

export function showPayslipPin(data) {
    const urlString = `/users/payslip/decrypt`;
    return axiosInstance.post(urlString, data, {
        headers: { ...getAuthorizationHeaders().headers },
    });
}